import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib/cn";

const badgeVariants = cva(
  "inline-flex h-5 shrink-0 items-center gap-1 rounded-full border px-2 font-mono text-[0.66rem] leading-none font-bold tracking-wide uppercase",
  {
    variants: {
      variant: {
        default: "border-primary/60 bg-primary/15 text-primary",
        neutral: "border-border bg-surface-raised text-foreground-muted",
        success: "border-success/60 bg-success/15 text-success",
        warning: "border-warning/60 bg-warning/15 text-warning",
        danger: "border-danger/60 bg-danger/15 text-danger",
        accent: "border-accent/70 bg-accent/20 text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

type BadgeProps = ComponentProps<"span"> & VariantProps<typeof badgeVariants>;

export function Badge({
  className,
  variant = "default",
  ...props
}: BadgeProps) {
  return (
    <span
      data-slot="badge"
      className={cn(badgeVariants({ className, variant }))}
      {...props}
    />
  );
}
